angular.module('impactx.greetingcard').controller('ProductGreetingCardListCtrl',  [
    'selectedListItems',
    ProductGreetingCardListCtrl]);

function ProductGreetingCardListCtrl(selectedListItems)
{
    var ctrl = this;

    this.getDetailLink = function() {
        return "productgreetingcard/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ProductGreetingCard'}
    ];

    this.meta = {
        rowTemplate: 'modules/greetingcard/templates/productgreetingcard.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/greetingcard/productgreetingcard/list',
        id: 'productgreetingcardlist',
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    };
}